import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import { useField, UseFieldProps } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { blue, oil } from "../hooks/use-map-theme-styles";
import { Options } from "../models/common/options";

function FormRadioGroup(props: UseFieldProps<any> & { options?: Array<Options>; label: string; required?: boolean; disabled?: boolean }) {
	const [field] = useField(props);
	const { t } = useTranslation();

	function getBooleanOptions(): Array<Options> {
		return [
			{ label: t("yes"), value: "true" },
			{ label: t("no"), value: "false" },
		];
	}

	const options = useMemo(() => props.options || getBooleanOptions(), [!!props.options]);

	return (
		<Box>
			<Typography style={{ fontSize: "16px", color: oil }}>
				{props.label}{" "}
				{!!props.required && (
					<Typography color="primary" style={{ display: "inline-block" }}>
						*
					</Typography>
				)}
			</Typography>
			<RadioGroup aria-labelledby={`${field.name}-radio-buttons-group`} row {...field}>
				{options.map((option, index) => (
					<FormControlLabel disabled={props.disabled} key={index} {...option} control={<Radio style={{ color: blue }} />} />
				))}
			</RadioGroup>
		</Box>
	);
}

export default FormRadioGroup;
